const DEFAULT_API_BASE_URL = '/api/v1';
const DEFAULT_REQUEST_TIMEOUT_MS = 60_000;

function normalizeRouterBasePath(value: string | undefined): string {
  const path = value?.trim() || '/';
  if (path === '/') return path;
  return `/${path.replace(/^\/+|\/+$/g, '')}`;
}

function positiveInteger(value: string | undefined, fallback: number): number {
  const parsed = Number.parseInt(value ?? '', 10);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
}

export const adminEnvironment = Object.freeze({
  name: import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE,
  title: import.meta.env.VITE_APP_TITLE?.trim() || '万剪师管理后台',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL?.trim() || DEFAULT_API_BASE_URL,
  routerBasePath: normalizeRouterBasePath(import.meta.env.VITE_APP_BASE_PATH),
  requestTimeoutMs: positiveInteger(
    import.meta.env.VITE_REQUEST_TIMEOUT,
    DEFAULT_REQUEST_TIMEOUT_MS,
  ),
});
